type Entry = { value: unknown; expires: number };

const store = new Map<string, Entry>();

const STATS_PREFIX = "stats:";
const MARKS_PREFIX = "marks:";
const TERR_PREFIX = "terr:";

export function statsKey(suffix: string): string {
  return `${STATS_PREFIX}${suffix}`;
}
export function marksKey(kind: string): string {
  return `${MARKS_PREFIX}${kind}`;
}
export function terrKey(suffix: string): string {
  return `${TERR_PREFIX}${suffix}`;
}

export function getCached<T>(key: string): T | undefined {
  const entry = store.get(key);
  if (!entry) return undefined;
  if (Date.now() > entry.expires) {
    store.delete(key);
    return undefined;
  }
  return entry.value as T;
}

export function setCached<T>(key: string, value: T, ttlMs: number): void {
  store.set(key, { value, expires: Date.now() + ttlMs });
}

/** Evict a single key. Used to drop a failed in-flight promise so the next
 *  read retries instead of serving a cached rejection. */
export function deleteCached(key: string): void {
  store.delete(key);
}

function deleteByPrefix(prefix: string): void {
  for (const key of store.keys()) {
    if (key.startsWith(prefix)) store.delete(key);
  }
}

/** Call after any mark change or dispute-mode change. */
export function invalidateStatsCache(): void {
  deleteByPrefix(STATS_PREFIX);
}

/** Call after markEntity/unmarkEntity for a given kind. */
export function invalidateMarksCache(kind: string): void {
  deleteByPrefix(marksKey(kind));
}

/** Call after dispute-mode change. Territory rows bake the user's modes into the
 *  result (not the cache key), so the next read must recompute. */
export function invalidateTerritoriesCache(): void {
  deleteByPrefix(TERR_PREFIX);
}

/** Call on login/logout. */
export function clearAllCaches(): void {
  store.clear();
}
